import { authMethod } from '../secure-portal/auth/Auth.constants';
import { Environment } from './environment.types';
import { filterNavigation } from './navigation';

const environment: Partial<Environment> = {
  apiBaseUrl: 'https://qms-api.sierralabs.com/api/',
  siteDomain: 'qms.sierralabs.com',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  expires: 365,
  secure: true,
  tinyApiKey: '28wr7ysrep8u469n6qqpzvzmn9uyye4phxcstpwrtdh6blk1',
  recaptchaSiteKey: '6LfLJtQjAAAAAF5Eymo01VfMF2qxtY7C1r8j-MxT',
  navigation: filterNavigation(
    'Dashboard',
    'Training Admin',
    'Quality Roadmap',
    'Audit Management',
    'Risk Management',
    'Documents',
    'Products',
    'Hazards',
    'CAPA',
    'SCAR',
    'Supplier Management',
    'Teams',
    'Employees',
    'Forms',
    'Workflow',
    'Task Types',
    'Agreements',
    'Sign Up'
  ),
  changeOrderConfig: { useCustomFields: true, enableQualityChangeFields: true },
  authConfig: { methods: [authMethod.default, authMethod.google] },
  googleAuthConfig: {
    clientId:
      '561300347562-tlbgciri0d7c8rhprprmi76mkc5ncoub.apps.googleusercontent.com'
  }
};

export default environment;
